// IMPORT REACT
import React from 'react';
import Axios from 'axios';
import { withRouter } from 'react-router-dom';

// IMPORT COMPONENTS
import YAFolder from './Folder';
import YAResource from './Resource';
import YAResourceAdd from './ResourceAdd';
import YAFolderAdd from './FolderAdd';
import YAButton from '../Form/Button';
import YARow from '../Grid/Row';
import YAColumn from '../Grid/Column';
import YAAlert from '../Alert';

// IMPORT STYLES
import { SC_ResourceList, SC_ResourceBreadcrumbs, SC_ResourceActionBar } from './styles';
import YAText from '../Text';

class YAResourceList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      user: null,
      editing: false,
      formSuccess: null,
      categories: [],
      files: null,
      path: null,
      selectedCategory: props.match.params.categoryid ? props.match.params.categoryid : 0
    };
  }

  componentDidMount() {
    this.getCategories(this.props.lang, this.state.selectedCategory).then(data => {
      this.setState({
        categories: data,
      });
    });
    this.getFiles(this.props.lang, this.state.selectedCategory).then(data => {
      this.setState({
        files: data.files,
        path: data.path
      });
    });
    this.getUser(this.props.lang).then(data => {
      this.setState({
        user: data
      });
    });
  }

  componentDidUpdate(previousProps, previousState) {
    let selectedCategory = this.props.match.params.categoryid ? this.props.match.params.categoryid : 0;

    if (selectedCategory != this.state.selectedCategory || previousState.formSuccess != this.state.formSuccess) {
      if (selectedCategory != this.state.selectedCategory) {
        this.setState({
          formSuccess: null,
          editing: false,
          selectedCategory: selectedCategory,
        });
      }
      this.getCategories(this.props.lang, selectedCategory).then(data => {
        this.setState({
          categories: data,
        });
      });
      this.getFiles(this.props.lang, selectedCategory).then(data => {
        this.setState({
          files: data.files,
          path: data.path
        });
      });
    }
  }

  getUser(lang) {
    let url = '/wp-json/wp/v2/weemarkable/user/';
    url += '?lang=';
    url += lang;
    return Axios({
      method: 'get',
      url: url,
      headers: {
        // eslint-disable-next-line no-undef
        'X-WP-Nonce': frontend_ajax_object.nonce
      },
    }).then((response) => {
      return response.data;
    }).catch(function (error) {
      console.log(error, 'Error');
    });
  }

  getCategories(lang, parent) {
    let url = '/wp-json/wp/v2/weemarkable/categories/';
    url += '?lang=';
    url += lang;
    url += '&parent=';
    url += parent;
    return Axios({
      method: 'get',
      url: url,
      headers: {
        // eslint-disable-next-line no-undef
        'X-WP-Nonce': frontend_ajax_object.nonce
      },
    }).then((response) => {
      return response.data;
    }).catch(function (error) {
      console.log(error, 'Error');
    });
  }

  getFiles(lang, category) {
    let url = '/wp-json/wp/v2/weemarkable/files/';
    url += '?lang=';
    url += lang;
    url += '&category=';
    url += category;
    return Axios({
      method: 'get',
      url: url,
      headers: {
        // eslint-disable-next-line no-undef
        'X-WP-Nonce': frontend_ajax_object.nonce
      },
    }).then((response) => {
      return response.data;
    }).catch(function (error) {
      console.log(error, 'Error');
    });
  }

  render() {
    let categories = this.state.categories;
    let files = this.state.files;
    let path = this.state.path;
    let formSuccess = this.state.formSuccess;
    let selectedCategory = this.state.selectedCategory;
    let user = this.state.user;
    let isWeemarkableSuperAdmin = user ? (user.user.caps.weemarkable_super_admin || user.user.caps.administrator) : false;

    return (
      path ?
        <SC_ResourceList>
          <SC_ResourceBreadcrumbs>
            <YARow>
              <YAColumn>
                {path.map((category, index) => {
                  const lastBtn = (path.length == index + 1);
                  return <YAButton color="link" bootstrap={lastBtn ? 'text-muted' : null} key={index} to={category.guid}>{category.name}</YAButton>
                })}
              </YAColumn>
              <YAColumn>

              </YAColumn>
            </YARow>
          </SC_ResourceBreadcrumbs>
          {isWeemarkableSuperAdmin && <SC_ResourceActionBar>
            <YAButton color="dark" size="sm" onClick={() => {
              this.setState({
                editing: 'add',
                formSuccess: null
              })
            }}>
              New Folder
          </YAButton>
            <YAButton color="dark" size="sm" onClick={() => {
              this.setState({
                editing: 'add-file',
                formSuccess: null
              })
            }}>
              Upload File
          </YAButton>


            {formSuccess &&
              <YAAlert color="success">
                {formSuccess}
              </YAAlert>}

          </SC_ResourceActionBar>}
          {isWeemarkableSuperAdmin && this.state.editing == 'add' &&
            <YAFolderAdd selectedCategory={selectedCategory} cancelCallbackFunction={(message) => {
              this.setState({
                editing: false,
                formSuccess: message
              });
            }} />}

          {isWeemarkableSuperAdmin && this.state.editing == 'add-file' &&
            <YAResourceAdd selectedCategory={selectedCategory} cancelCallbackFunction={(message) => {
              this.setState({
                editing: false,
                formSuccess: message
              });
            }} />}

          <ResourceFolders categories={categories} selectedCategory={selectedCategory} isWeemarkableSuperAdmin={isWeemarkableSuperAdmin} editing={isWeemarkableSuperAdmin ? this.state.editing : false} startEditingCallbackFunction={(id) => {

            this.setState({
              editing: id,
              formSuccess: null
            })
          }} cancelCallbackFunction={(message) => {
            this.setState({
              editing: false,
              formSuccess: message
            });
          }} />
          <ResourceFiles categories={categories} files={files} selectedCategory={selectedCategory} isWeemarkableSuperAdmin={isWeemarkableSuperAdmin} editing={isWeemarkableSuperAdmin ? this.state.editing : false} startEditingCallbackFunction={(id) => {

            this.setState({
              editing: id,
              formSuccess: null
            })
          }} cancelCallbackFunction={(message) => {
            this.setState({
              editing: false,
              formSuccess: message
            });
          }} />
        </SC_ResourceList> : null
    )
  }
}

const ResourceFolders = ({ categories, editing, selectedCategory, isWeemarkableSuperAdmin, startEditingCallbackFunction, cancelCallbackFunction }) => {
  return (
    categories.length ? categories.map((category, index) => {
      return <YAFolder
        key={index}
        category={category}
        editing={editing}
        selectedCategory={selectedCategory}
        isWeemarkableSuperAdmin={isWeemarkableSuperAdmin}
        startEditingCallbackFunction={(id) => {
          startEditingCallbackFunction(id)
        }}
        cancelCallbackFunction={(message) => {
          cancelCallbackFunction(message)
        }}
      />
    }) : null
  );
}

const ResourceFiles = ({ categories, files, editing, selectedCategory, isWeemarkableSuperAdmin, startEditingCallbackFunction, cancelCallbackFunction }) => {
  return (
    files && files.length ? files.map((file, index) => {
      return <YAResource
        key={index}
        file={file}
        editing={editing}
        selectedCategory={selectedCategory}
        startEditingCallbackFunction={(id) => {
          startEditingCallbackFunction(id)
        }}
        isWeemarkableSuperAdmin={isWeemarkableSuperAdmin}
        cancelCallbackFunction={(message) => {
          cancelCallbackFunction(message)
        }}
      />
    }) : files && !categories.length ? <YAResource
      key={0}
      file={null}
    /> : null
  );
}

export default withRouter(YAResourceList);